import { useCallback } from 'react';
import { useClearRefinements, useInstantSearch } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { ExtendedUIState } from '@sorare/core/src/components/search/InstantSearch/types';
import { useSearchCardsContext } from '@sorare/core/src/contexts/searchCards';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { filters } from '@sorare/core/src/lib/glossary';

import { useFiltersCount } from 'search/FiltersManager/useFiltersCount';

export const useClearAllFilters = () => {
  const track = useEvents();
  const { sport } = useSportContext();
  const filtersCount = useFiltersCount();
  const { refine: clearRefinements } = useClearRefinements({
    // this is required to also clear the query string
    excludedAttributes: ['revealableCardCampaign.name'],
  });
  const { clearFilters } = useSearchCardsContext();
  const { setIndexUiState } = useInstantSearch<ExtendedUIState>();

  return useCallback(() => {
    if (sport) {
      track('Clear Market Filters', {
        filtersCount,
      });
    }
    clearFilters();
    clearRefinements();
    setIndexUiState(uiState => {
      return {
        ...uiState,
        exclusions: {},
      };
    });
  }, [
    clearFilters,
    clearRefinements,
    filtersCount,
    setIndexUiState,
    sport,
    track,
  ]);
};

export const ClearAllFilters = () => {
  const clearAllFilters = useClearAllFilters();

  return (
    <Button onClick={clearAllFilters} size="medium" color="quaternary">
      <FormattedMessage {...filters.clearAll} />
    </Button>
  );
};
